
<div class="report-container">
  <hyperkit-typography variant="h5">Overview</hyperkit-typography>
  <hunt-details-editor 
  title="Executive Summary" 
  [value]="huntContext.editor.executiveSummary()"
  (valueChange)="huntContext.editor.updateExecutiveSummary($event)"
>
</hunt-details-editor>
  <hunt-details-editor 
    title="Abstract" 
    [value]="huntContext.editor.abstract()"
    (valueChange)="huntContext.editor.updateAbstract($event)"
  >
  </hunt-details-editor>
  <hunt-details-editor 
  title="Hypothesis" 
  [value]="huntContext.editor.hypothesis()"
  (valueChange)="huntContext.editor.updateHypothesis($event)"
  >
</hunt-details-editor>
</div>
